/* ============================================================
   adv.js — immi advertorial runtime
   Responsibilities, in order of how badly it hurts if missing:
     1. Forward ALL inbound query params to every CTA (UTMs,
        fbclid, discount). The extra hop must not drop attribution.
     2. Stamp the arm param so the advertorial arm is separable
        from the direct-to-LP control arm at the LP / in orders.
     3. Reading progress bar.
     4. Sticky CTA reveal after a scroll threshold.
     5. CTA click + scroll-depth events to dataLayer / gtag.
     6. Countdown (Style B only).
   ============================================================ */
(function () {
  "use strict";

  var root = document.querySelector("[data-adv-root]");
  if (!root) return;

  var ARM_KEY = root.getAttribute("data-adv-arm-key") || "adv";
  var ARM_VAL = root.getAttribute("data-adv-arm-value") || "";
  var STICKY_AT = parseInt(root.getAttribute("data-adv-sticky-at") || "50", 10);

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- 0: noindex ----------
     Advertorials should never be indexed. NOTE: this is the JS fallback.
     Google honours JS-injected robots meta during rendering, but the
     bulletproof version is one conditional line in layout/theme.liquid:
       {%- if template.suffix contains 'adv-' -%}
         <meta name="robots" content="noindex,nofollow">
       {%- endif -%}
     That edits an existing theme file, so it needs sign-off first. */
  if (root.getAttribute("data-adv-noindex") === "true" &&
      !document.querySelector('meta[name="robots"]')) {
    var m = document.createElement("meta");
    m.setAttribute("name", "robots");
    m.setAttribute("content", "noindex,nofollow");
    (document.head || document.documentElement).appendChild(m);
  }

  /* ---------- 1 + 2: param forwarding + arm stamping ---------- */
  var inbound = new URLSearchParams(window.location.search);

  function decorate(href) {
    if (!href) return href;
    // leave anchors, mailto, tel alone
    if (/^(#|mailto:|tel:)/i.test(href)) return href;
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return href;
    }
    // Only decorate same-origin links. Cross-origin would leak params
    // and the LP is same-domain by design.
    if (url.origin !== window.location.origin) return href;

    inbound.forEach(function (v, k) {
      if (!url.searchParams.has(k)) url.searchParams.set(k, v);
    });
    if (ARM_VAL) url.searchParams.set(ARM_KEY, ARM_VAL);
    return url.pathname + (url.search || "") + (url.hash || "");
  }

  function decorateAll() {
    $$("[data-adv-cta]").forEach(function (a) {
      if (a.getAttribute("data-adv-decorated") === "1") return;
      a.setAttribute("href", decorate(a.getAttribute("href")));
      a.setAttribute("data-adv-decorated", "1");
    });
  }
  decorateAll();

  /* ---------- 5: analytics ---------- */
  function emit(name, payload) {
    payload = payload || {};
    payload.event = name;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {}
    try {
      if (typeof window.gtag === "function") window.gtag("event", name, payload);
    } catch (e) {}
  }

  $$("[data-adv-cta]").forEach(function (a) {
    a.addEventListener("click", function () {
      emit("adv_cta_click", {
        adv_position: a.getAttribute("data-adv-cta") || "unknown",
        adv_label: (a.textContent || "").trim().slice(0, 60),
        adv_arm: ARM_VAL
      });
    });
  });

  var depths = [25, 50, 75, 100];
  var fired = {};
  function docHeight() {
    var b = document.body, e = document.documentElement;
    return Math.max(b.scrollHeight, e.scrollHeight, b.offsetHeight, e.offsetHeight);
  }

  /* ---------- 3 + 4: progress bar + sticky CTA ---------- */
  var bar = $("[data-adv-progress]");
  var sticky = $("[data-adv-sticky]");
  var ticking = false;

  function onScroll() {
    var scrolled = window.pageYOffset || document.documentElement.scrollTop;
    var max = docHeight() - window.innerHeight;
    var pct = max > 0 ? Math.min(100, Math.max(0, (scrolled / max) * 100)) : 0;

    if (bar) bar.style.width = pct.toFixed(2) + "%";
    if (sticky) sticky.classList.toggle("is-visible", pct >= STICKY_AT);

    depths.forEach(function (d) {
      if (!fired[d] && pct >= d) {
        fired[d] = true;
        emit("adv_scroll_depth", { adv_depth: d, adv_arm: ARM_VAL });
      }
    });
    ticking = false;
  }

  window.addEventListener("scroll", function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
  }, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  onScroll();

  /* ---------- 6: countdown (Style B) ---------- */
  var cd = $("[data-adv-countdown]");
  if (cd) {
    var mins = parseInt(cd.getAttribute("data-adv-countdown") || "0", 10);
    if (mins > 0) {
      var KEY = "adv_cd_" + (window.location.pathname || "p");
      var end;
      try {
        end = parseInt(window.sessionStorage.getItem(KEY) || "0", 10);
      } catch (e) { end = 0; }
      var now = Date.now();
      if (!end || end < now) {
        end = now + mins * 60000;
        try { window.sessionStorage.setItem(KEY, String(end)); } catch (e) {}
      }
      var hEl = $("[data-cd-h]", cd), mEl = $("[data-cd-m]", cd), sEl = $("[data-cd-s]", cd);
      var pad = function (n) { return (n < 10 ? "0" : "") + n; };
      var tick = function () {
        var left = Math.max(0, end - Date.now());
        var t = Math.floor(left / 1000);
        if (hEl) hEl.textContent = pad(Math.floor(t / 3600));
        if (mEl) mEl.textContent = pad(Math.floor((t % 3600) / 60));
        if (sEl) sEl.textContent = pad(t % 60);
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  // Re-decorate if the theme injects links late (apps, embeds).
  if (window.MutationObserver) {
    new MutationObserver(decorateAll).observe(document.body, { childList: true, subtree: true });
  }
})();
